import { formatDateDash } from '@shared/utils/dateUtils';
import { useEffect, useState } from 'react';

import { getCorrespondentRequests } from '@shared/services/api/correspondentRequestService';
import { StatusBadge } from '@subpages/components/StatusBadge';

export const useCorrespondentsRequests = (page, size, searchParams) => {
  const [currentPage, setCurrentPage] = useState(page);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(size);
  const [search, setSearch] = useState(searchParams);
  const [correspondentsRequests, setCorrespondentsRequests] = useState({
    data: [],
    total: 0,
  });

  const fetchCorrespondentsRequests = async () => {
    const { data, total } = await getCorrespondentRequests(search, currentPage, pageSize);

    const filteredData = data.map(
      ({
        request_id,
        commercial_name: commercialName = '-',
        account_number: accountNumber = '-',
        date_created,
        manager,
        state,
        date_updated,
        code: status,
        service_months: serviceMonths = 0,
        address = '-',
        lat,
        long,
        reference = '',
        manager_name,
        rejection_reason,
        holder,
        correspondent_id,
      }) => ({
        request_id,
        commercial_name: commercialName,
        account_number: accountNumber,
        date_created: formatDateDash(date_created) || '-',
        manager: manager || '-',
        state: state || '-',
        date_updated: formatDateDash(date_updated) || '-',
        code: <StatusBadge status={status} />,
        service_months: serviceMonths,
        address,
        lat,
        long,
        reference,
        statusRequest: status,
        manager_name,
        rejection_reason,
        holder,
        correspondent_id,
      })
    );

    setCorrespondentsRequests({
      data: filteredData,
      total: total || 0,
    });
    setCount(total || 0);
  };

  useEffect(() => {
    fetchCorrespondentsRequests();
  }, [currentPage, pageSize, search]);

  function nextPage(page, selectedSize) {
    setCurrentPage(page);
    setPageSize(selectedSize);
  }

  return {
    ...correspondentsRequests,
    fetchCorrespondentsRequests,
    currentPage,
    count,
    setSearch,
    search,
    nextPage,
  };
};
